import styled from "@emotion/styled";

import { FONT_WEIGHT_NORMAL } from "../utilities";

export const EndAdornment = styled.span`
  font-weight: ${FONT_WEIGHT_NORMAL};
  white-space: nowrap;
`;
